<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisores"
          :url="link"
        />
        <br><br>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <v-containaer>
              <v-row>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :code-information="'140'"
                    :texto-information="textoFaturamento"
                    :text="'Faturamento'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingVendas1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :code-information="'371'"
                    :texto-information="textoFaturamentoAnteior"
                    :text="'Fatu. do Mês no Ano Anterior'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoAnoAnterior"
                    :padding="dynamicPaddingVendas1"
                    :loading="loadingFaturamentoAnoAnterior"
                  />
                </v-col>
              </v-row>
            </v-containaer>
          </v-col>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :exibir-informacao="true"
              :text="'Comparativo Faturamento'"
              :code-information="'372'"
              :texto-information="textoCompativoFaturamento"
              :style-object="styleObject"
              :componente-grafico="true"
              :grafico-id="'myChart7'"
              :dados-grafico="chartBarLinha"
              :titulo-id="'myChart7'"
              :legenda-grafico="legendaGrafico"
              :exibir-legenda="true"
              :padding="dynamicPaddingVendas2"
              :loading="loadingFaturamento7MesesAnteriores"
            />
          </v-col>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :exibir-informacao="true"
              :text="'Acumulado Comparativo Faturamento'"
              :code-information="'373'"
              :texto-information="textoFaturamentoAcumulado"
              :style-object="styleObject"
              :componente-grafico="true"
              :grafico-id="'myChart9'"
              :dados-grafico="chartBarAcumuladoAnual"
              :titulo-id="'myChart9'"
              :padding="dynamicPaddingVendas3"
              :loading="loadingFaturamentoAcumuladoAnual"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está o acumulado do ano até o mês atual?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('141')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '141'"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-vendas-meses-do-ano />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="12"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Quais foram os principais clientes?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('142')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="carregandoTooltip"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="18"
                              width="2"
                              class="mr-2"
                            />
                            Carregando Orientação...
                          </div>
                          <div
                            v-if="codigo === '142' && !carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <show-faturamento-principais-clientes-vendas />
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="12"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Como está o faturamento dos meus grupos de itens?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('149')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="carregandoTooltip"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="18"
                              width="2"
                              class="mr-2"
                            />
                            Carregando Orientação...
                          </div>
                          <div
                            v-if="codigo === '149' && !carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <show-faturamento-grupos-produtos-vendas />
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual minha evolução de vendas?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('144')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '144' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-supervisor-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    E referente a evolução em volume de venda?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('145')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '145' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-volume-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Vendas from '../../../../services/vendas'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'PageComercial',
    emits: ['updateDadosClientesVendas', 'updateDatasVendas', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardVendasMesesDoAno: () => import('../../graficos/Vendas/VendasMesesdoAno'),
      ShowFaturamentoPrincipaisClientesVendas: () => import('../../components/comercial/vendas/FaturamentoPrincipaisClienteVendas'),
      ShowFaturamentoGruposProdutosVendas: () => import('../../components/comercial/vendas/FaturamentoGrupoProdutosClassificacaoVendas'),
      ShowEvolucaoSupervisorVendas: () => import('../../components/comercial/vendas/FaturamentoEvolucaoSupervisorVendas'),
      ShowEvolucaoVolumeVendas: () => import('../../components/comercial/vendas/FaturamentoEvolucaoVolumeVendas'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      supervisor: [],
      vendedores: [],
      areas: [],
      redes: [],
      receita: [],
      segmento: [],
      textoFaturamento: '',
      textoFatAcumulado: '',
      textoPrincipaisClientes: '',
      textoFatGrupoItens: '',
      textoFatEvolucaoVendas: '',
      textoVolumeEvolucaoVendas: '',
      textoFaturamentoAnteior: '',
      textoCompativoFaturamento: '',
      textoFaturamentoAcumulado: '',
      codigo: 0,
      orientacao: [],
      codigoIds: ['140', '141', '142', '149', '144', '145', '315', '317', '371', '372', '373'],
      permissaoVenda: '',
      enableFatPrinCliente: false,
      enableEvolucaoVendas: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisores: true,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      legendaGrafico: [
        { cor: '#ed934f', status: 'Variação Anual de Faturamento' },
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      chartBarLinha: {},
      chartBarAcumuladoAnual: {},
      chartBarAcumuladoMensal: {},
      legendaGraficoMensal: [
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      dynamicPaddingTitulo: '',
      dynamicPaddingVendas1: '',
      dynamicPaddingVendas2: '',
      dynamicPaddingVendas3: '',
      dynamicPaddingVendas4: '',
      dynamicPaddingVendas5: '',
      dynamicPaddingVendas6: '',
      loadingFaturamento: false,
      loadingFaturamentoAnoAnterior: false,
      loadingFaturamento7MesesAnteriores: false,
      loadingFaturamentoAcumuladoAnual: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 104rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 11rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 44rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 15rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 104rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 37rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 104rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 83rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 10rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 38rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 14rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 83rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 28.1rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 83rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingTitulo = 'padding-right: 10rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 9rem !important'
        } else if (window.innerWidth > 680 && window.innerWidth < 1000) {
          this.dynamicPaddingTitulo = 'padding-right: 10rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingTitulo = 'padding-right: 64rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 5rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 28rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 64rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 18rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 64rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisores
        this.vendedores = vendedores
        this.areas = areas
        this.redes = redes
        this.segmento = segmento

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async updateDate () {
        eventEmit.$emit('update-datas-vendas', this.primeiroDia, this.date, this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, this.segmento, [], [], [])
        eventEmit.$emit('update-dados-clientes-vendas', this.primeiroDia, this.date, this.select, this.supervisor, this.receita, [], [], [])

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.loadingFaturamento = true
        this.loadingFaturamentoAnoAnterior = true
        this.loadingFaturamento7MesesAnteriores = true
        this.loadingFaturamentoAcumuladoAnual = true

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartBarAcumuladoAnual.data) {
          this.chartBarAcumuladoAnual.destroy()
        }

        await Vendas.showFaturamentoVendas(this.primeiroDia, this.date, this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, localStorage.tokencontrato, this.segmento, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamento = this.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Vendas.showFaturamentoMesAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, localStorage.tokencontrato, this.segmento, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamentoAnoAnterior = false })

        await Vendas.showFaturamento7MesesAnteriores(this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, localStorage.tokencontrato, this.segmento, [], [], []).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart7').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datasFaturamento,
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: resposta.data.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: resposta.data.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return resposta.data.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamento7MesesAnteriores = false })

        await Vendas.showFaturamento7MesesAnteriores(this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, localStorage.tokencontrato, this.segmento, [], [], []).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart9').getContext('2d')

            this.chartBarAcumuladoAnual = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Ano Corrente'],
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: [resposta.data.somatorioAnoAnterior],
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Faturamento',
                    data: [resposta.data.somatorioAnoCorrente],
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    align: 'top',
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Ano Anterior'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.chartBarAcumuladoAnual.data) {
              this.chartBarAcumuladoAnual.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoAcumuladoAnual = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #faturamentoVendas2 {
      font-size: 14px;
      margin: -1rem 0 0 -21rem;
    }

    #componentevlrFatVendas2 {
      margin: -1rem 0 0 0.3rem
    }

    #faturamentoMesAnoAnteriorVendas2 {
      font-size: 14px;
      margin: -5.6rem 0 0 14rem;
    }

    #componentevlrFatMesAnteriorVendas2 {
      margin: -1rem 0 0 -2rem;
    }

    #componenteVenda7MesesAnterioresVendas2 {
      margin: 0rem 0 0 2rem;
    }

    #textoPrincipaisClientesVendas2 {
      width: 100%;
      font-size: 12px;
    }

    #iconInformationAcumuladoAnualVendas2 {
      margin: -6.5rem 0 0 25rem;
    }

    #dividirIdVendas2 {
      margin: -4rem 0 0 0rem;
    }

    #listItemFaturamentoVendas {
      margin: -1rem 0 0 -1rem
    }

    #listItemGrupoItens {
      margin: -1rem 0 0 -1rem
    }

    #listItemEvolucaoVolumeVendas {
      margin: -1rem 0 0 -1rem
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoVendas2 {
      font-size: 18px;
      margin: 1rem 0 0 -4rem;
    }

    #componentevlrFatVendas2 {
      margin: 0 0 0 10rem;
    }

    #faturamentoMesAnoAnteriorVendas2 {
      font-size: 18px;
      margin: 1rem 0 0 2rem;
    }

    #componentevlrFatMesAnteriorVendas2 {
      margin: 0 0 0 6rem
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoVendas2 {
      margin: 0 0 0 -5rem !important;
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoVendas2 {
      margin: 0 0 0 -5rem !important;
    }

    #iconInformationAcumuladoAnualVendas2 {
      margin: 0 0 0 15rem;
    }

    #iconInformationAcumuladoAnualComparativoVendas2 {
      margin: 0 0 0 4.2rem
    }

    #iconInformationEvolucaoVendasVendas2 {
      margin: 0 0 0 5.4rem
    }

    #iconInformationEvolucaoVolumeVendaVendas2 {
      margin: 0 0 0 5.4rem
    }
  }
</style>

<style lang="sass">
  #iconInformationAcumuladoAnualVendas2
    margin: 0 0 0 10rem

  #faturamentoVendas2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -5rem
    font-weight: bold

  #componentevlrFatVendas2
    margin: 0 0 0 3.5rem

  #faturamentoMesAnoAnteriorVendas2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 3rem
    font-weight: bold

  #componentevlrFatMesAnteriorVendas2
    margin: 0 0 0 -0.5rem

  #iconInformationAcumuladoAnualComparativoVendas2
    margin: 0 0 0 2.5rem

  #iconInformationEvolucaoVendasVendas2
    margin: 0 0 0 3.4rem

  #iconInformationEvolucaoVolumeVendaVendas2
    margin: 0 0 0 3.4rem

  #btnRefazerVendas
    margin: 1.5rem auto

  .textoAcumuladoAnualVendas2
    margin: 0 0 1rem 1rem

  #textoFaturamentoClienteProdutoVendas2
    margin: 0 0 0.2rem 1rem

  #textoEvolucaoVendaVendas2
    margin: 0 0 0 1rem

  #legendaVendas
    font-size: 12px

  #listItemFaturamentoVendas
    margin: -2rem 0 0 -1rem

  #componenteFaturamento
    margin: -3rem 0 0 0

  #listItemPrincipaisClientes
    margin: -2rem 0 0 -1rem

  #listItemGrupoItens
    margin: -2rem 0 0 -1rem

  #listItemEvolucaoVendas
    margin: -2rem 0 0 -1rem

  #listItemEvolucaoVolumeVendas
    margin: -2rem 0 0 -1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

</style>
